import { getUserId, type SendMessageInterface } from "./utils/utils";

/**
 * Где вызывается отправка: дашборд (список чатов с поддержкой/маркетингом) или карточка клиента/заявки.
 */
export type ChatSendPreset = "dashboard" | "crm_contact";

const MESSENGER_CHANNEL_TYPES = new Set<string>([
    "whatsapp",
    "whatsgroup",
    "instagram",
    "telegram",
    "telegroup",
    "vk",
    "avito",
]);

/**
 * Единая логика `chat_type` для `/api/trigger/message` (как в дашборде), с различием:
 * - дашборд: поддержка/маркетинг и мессенджеры из данных контакта;
 * - клиенты/заявки: без support/marketer — канал обычной переписки (по умолчанию whatsapp).
 */
export function resolveSendMessageChatType(
    preset: ChatSendPreset,
    contactChatType?: string | null
): string {
    if (preset === "crm_contact") {
        return "whatsapp";
    }
    if (contactChatType === "support" || contactChatType === "marketer") {
        return contactChatType;
    }
    if (contactChatType && MESSENGER_CHANNEL_TYPES.has(contactChatType)) {
        return contactChatType;
    }
    return "support";
}

export interface BuildSendMessageApiPayloadInput {
    userId: string | number | null | undefined;
    chatId: string | null;
    messageType: string;
    textTrimmed: string;
    normalizedAttachment: SendMessageInterface["attachment_file"];
    chatTypeForApi: string;
    timestamp: number;
}

/**
 * Тело запроса на создание сообщения — одна точка сборки параметров для `postMessage`.
 */
export function buildSendMessageApiPayload(
    input: BuildSendMessageApiPayloadInput
): SendMessageInterface {
    const {
        userId,
        chatId,
        messageType,
        textTrimmed,
        normalizedAttachment,
        chatTypeForApi,
        timestamp,
    } = input;

    return {
        user_id: getUserId(userId),
        chat_id: chatId,
        sender_id: Number(userId),
        ...(messageType === "text" && { text: textTrimmed || "" }),
        attachment_file: normalizedAttachment,
        type: messageType,
        chat_type: chatTypeForApi,
        status: "wait",
        timestamp,
    };
}
